import React, { useState } from 'react';
import { matchPath } from 'react-router-dom';
import { uniqueId } from 'lodash';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Loading from 'components/shared/Loading';
import useFetch from 'hooks/useFetch';
import { routes } from 'constants/config';

const isLibraryPath = pathname => !!matchPath(pathname, { path: '/library' });

const getRecapUrl = ({ pathname }, pathId, lessonId) => {
  const isLearningLibraryPath = isLibraryPath(pathname);

  if (isLearningLibraryPath) {
    return pathId
      ? routes.LEARNING.REPORT_CARD.LIBRARY_PATH_LESSON_RECAP(pathId, lessonId)
      : routes.LEARNING.REPORT_CARD.LIBRARY_LESSON_RECAP(lessonId);
  }

  return pathId
    ? routes.LEARNING.REPORT_CARD.PATH_LESSON_RECAP(pathId, lessonId)
    : routes.LEARNING.REPORT_CARD.LESSON_RECAP(lessonId);
};

const LessonRecap = ({ location, match: { params } }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const { lessonId, pathId } = params;
  const recapUrl = getRecapUrl(location, pathId, lessonId);
  const { data = {}, loading } = useFetch(recapUrl);

  const formattedTakeaways = () =>
    data.keyTakeaways
      ?.split('\n')
      .map((text, i) => <li key={uniqueId(`${text}`)}>{text}</li>);

  return (
    <div className="mb-24">
      <h4 className="tt-u">{t('progress.report_card.lesson_recap.title')}</h4>
      <Text variant={TEXT_VARIANTS.BODY}>
        {t('progress.report_card.lesson_recap.description')}
      </Text>
      {loading ? (
        <Loading loading />
      ) : (
        <>
          <TabbedView onSelect={setTabIndex} selectedIndex={tabIndex}>
            <TabList>
              {data.recap && (
                <Tab>{t('progress.report_card.lesson_recap.recap')}</Tab>
              )}
              {data.keyTakeaways && (
                <Tab>
                  {t('progress.report_card.lesson_recap.key_takeaways')}
                </Tab>
              )}
            </TabList>
            {data.recap && (
              <TabPanel data-testid="recap-tab">
                <div className="mb-24 mt-8">{data.recap}</div>
              </TabPanel>
            )}
            {data.keyTakeaways && (
              <TabPanel>
                <ul
                  className="mb-16 mt-8 pl-24"
                  data-testid="key-takeaways-tab"
                >
                  {formattedTakeaways()}
                </ul>
              </TabPanel>
            )}
          </TabbedView>
        </>
      )}
    </div>
  );
};

export default LessonRecap;
